import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'

export const openImageContextSelector = (state) => {
    const {images, users, openImage, editHistory} = state;
    const {id, userId, amplitude, spread} = openImage;
    const userImages = (!isNil(userId) && !isEmpty(images)) ? images[userId] : null;
    const imageInfo = (!isNil(id) && !isEmpty(userImages)) ? userImages[id] : null;
    const user = (!isNil(userId) && !isEmpty(users)) ? users[userId] : null;
    const imageEditHistory = (!isNil(id) && !isEmpty(editHistory)) ? editHistory[id] : null;
    return {id, images, userId, imageInfo, userImages, user, amplitude, spread, openImage, imageEditHistory};
};



// WEBPACK FOOTER //
// ./src/reducers/openImageContextSelector.js